import React from "react";
import { createPortal } from "react-dom";
import PropTypes from "prop-types";
import { Button } from "reactstrap";

const CustomModal = ({
  isOpen,
  toggle,
  type = "form",
  title,
  text,
  children,
  onSave,
  onSaveText = "Save",
  onCancel,
  onConfirm,
  showYesButton = true,
  showNoButton = true,
  yesButtonText = "Yes",
  noButtonText = "No",
  showFooterButtons = true,
}) => {
  if (!isOpen) return null;

  return createPortal(
    <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1055 }}>
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable" style={{ maxWidth: "min(500px, calc(100vw - 24px))", margin: "1.75rem auto" }}>
        <div className="modal-content">
          <div className="modal-header" style={{ borderBottom: "none" }}>
            <h6 className="text-lg font-semibold text-primary dark:text-white transition-colors duration-200 m-0 text-uppercase mt-2">
              {title || (type === "confirm" ? "Confirm" : "")}
            </h6>
            <button type="button" className="btn-close" onClick={toggle}></button>
          </div>

          <div className="modal-body" style={{ maxHeight: "calc(85vh - 130px)", overflowY: "auto" }}>
            {type === "confirm" ? <p>{text}</p> : children}
          </div>

          <div className="modal-footer" style={{ borderTop: "none" }}>
            {type === "confirm" ? (
              <>
                {showYesButton && (
                  <Button color="danger" onClick={onConfirm || toggle}>
                    {yesButtonText}
                  </Button>
                )}
                {showNoButton && (
                  <Button color="secondary" onClick={toggle}>
                    {noButtonText}
                  </Button>
                )}
              </>
            ) : showFooterButtons ? (
              <>
                <Button color="success" onClick={onSave || toggle}>
                  {onSaveText}
                </Button>
                <Button color="secondary" onClick={onCancel || toggle}>
                  Cancel
                </Button>
              </>
            ) : (
              <Button color="secondary" onClick={toggle}>
                Close
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

CustomModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  type: PropTypes.oneOf(["form", "confirm", "custom"]),
  title: PropTypes.string,
  text: PropTypes.string,
  children: PropTypes.node,
  onSave: PropTypes.func,
  onSaveText: PropTypes.string,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  showYesButton: PropTypes.bool,
  showNoButton: PropTypes.bool,
  yesButtonText: PropTypes.string,
  noButtonText: PropTypes.string,
  showFooterButtons: PropTypes.bool,
};

export default CustomModal;